import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LoadScript from "vue-plugin-load-script";
import { createGtm } from '@gtm-support/vue-gtm';

import '@/assets/css/lib/jquery-ui.min.css'
import '@/assets/css/lib/jquery-ui.structure.min.css'
import '@/assets/css/lib/jquery-ui.theme.min.css'
import '@/assets/css/lib/slick.css'

import '@/assets/css/reset.css'
import '@/assets/css/animate.css'
import '@/assets/css/common.css'
import '@/assets/css/diagnose.css'
import '@/assets/css/lp.css'
import '@/assets/css/myPage.css'


// import '@/assets/js/lib/jquery-3.4.1.min.js'
// import '@/assets/js/lib/jquery-ui.min.js'
// import '@/assets/js/lib/jquery.waypoints.min.js'
// import '@/assets/js/lib/slick.min.js'

// import '@/assets/js/bundle'
// import '@/assets/js/common'
import '@/assets/js/mypage'

createApp(App).use(store).use(router).use(LoadScript).mount('#app')

const app = createApp(App);
app.use(
  createGtm({
    id: 'GTM-WN44L88',
    vueRouter: router
  }),
);